// ===========================================
// GAME SCALE HOOK
// ===========================================
// Calculates the game table scale factor for zoom-resistant UI elements.
// Uses the same calculation as GameTable.tsx to ensure consistency.

import { useState, useEffect } from 'react';

// Fixed design resolution (16:9 aspect ratio) - must match GameTable.tsx
const CANVAS_WIDTH = 1920;
const CANVAS_HEIGHT = 1080;
const HEADER_HEIGHT = 56; // h-14 = 56px - must match GameTable.tsx

/**
 * Hook that returns the current game table scale factor.
 * Updates on window resize to stay in sync with the game table.
 */
export function useGameScale(): number {
  const [scale, setScale] = useState(() => calculateScale());

  useEffect(() => {
    const handleResize = () => {
      setScale(calculateScale());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return scale;
}

function calculateScale(): number {
  const scaleX = window.innerWidth / CANVAS_WIDTH;
  const scaleY = (window.innerHeight - HEADER_HEIGHT) / CANVAS_HEIGHT;
  return Math.min(scaleX, scaleY);
}

export default useGameScale;
